'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002433 from "./presto.-Agent-View$$anon$33.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002434 from "./presto.-Agent-View$$anon$34.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002435 from "./presto.-Agent-View$$anon$35.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002436 from "./presto.-Agent-View$$anon$36.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002437 from "./presto.-Agent-View$$anon$37.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002439 from "./presto.-Agent-View$$anon$39.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002441 from "./presto.-Agent-View$$anon$41.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002443 from "./presto.-Agent-View$$anon$43.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002444 from "./presto.-Agent-View$$anon$44.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$32() {
  this.aza = null;
  this.az8 = null;
  this.az9 = false;
  this.az6 = null;
  this.az7 = false;
  this.azb = false;
  this.azc = false;
  this.aza = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$32 as $c_Lpresto_AgentView$$anon$32 };
$p = $c_Lpresto_AgentView$$anon$32.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$32;
/** @constructor */
function $h_Lpresto_AgentView$$anon$32() {
}
export { $h_Lpresto_AgentView$$anon$32 as $h_Lpresto_AgentView$$anon$32 };
$h_Lpresto_AgentView$$anon$32.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aza;
});
$p.t = (function() {
  if ((!this.az9)) {
    this.az8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ErrorMessage", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalShodoSignResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalShodoCertChainResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeCertChainResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignFileResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignFileBase64Response", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignHashResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("UploadFileResponse", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.az9 = true;
  }
  return this.az8;
});
$p.ag = (function() {
  if ((!this.az7)) {
    this.az6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002433.$c_Lpresto_AgentView$$anon$33(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002434.$c_Lpresto_AgentView$$anon$34(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002435.$c_Lpresto_AgentView$$anon$35(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002436.$c_Lpresto_AgentView$$anon$36(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002437.$c_Lpresto_AgentView$$anon$37(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002439.$c_Lpresto_AgentView$$anon$39(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002441.$c_Lpresto_AgentView$$anon$41(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002443.$c_Lpresto_AgentView$$anon$43(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.az7 = true;
  }
  return this.az6;
});
$p.v = (function() {
  if ((!this.azc)) {
    this.azb = true;
    this.azc = true;
  }
  return this.azb;
});
$p.cES = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dAgent$002dView$0024$0024anon$002444.$c_Lpresto_AgentView$$anon$44().cNC(a), a);
});
$p.ae = (function(a) {
  return this.cES(a);
});
var $d_Lpresto_AgentView$$anon$32 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$32, "presto.AgentView$$anon$32", ({
  E2: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$32 as $d_Lpresto_AgentView$$anon$32 };
//# sourceMappingURL=presto.-Agent-View$$anon$32.js.map
